// extracted by mini-css-extract-plugin
export default {"container":"ResultCount_container__2MI0s"};